import React from 'react';
import { disclaimer } from '../data/mock';
import { AlertCircle } from 'lucide-react';

const DisclaimerSection = () => {
  return (
    <section className="py-16 lg:py-20 bg-[#FFFEF8]">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="p-8 lg:p-10 border border-[#E5E4DE]">
          <div className="flex items-start gap-4">
            <AlertCircle className="w-6 h-6 text-[#B8A88A] flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-lg font-normal text-[#333333] mb-3">
                {disclaimer.title}
              </h3>
              <p className="text-sm text-[#666666] leading-relaxed">
                {disclaimer.text}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DisclaimerSection;
